const VERSION = '6.1.9';

export { VERSION };
